import React from 'react';
import PropTypes from 'prop-types';

import { Stack, Typography } from '@metarouter-private/mr-mui';
import CenteredLoader from 'app/components/CenteredLoader';

export default function DeployedIntegrationsLoadingIndicator({ loading }) {
  if (!loading) {
    return null;
  }

  return (
    <Stack spacing={0} display="flex" flexDirection="column" justifyContent="center" alignItems="center">
      <CenteredLoader />
      <Typography variant="caption">Loading deployed integrations</Typography>
    </Stack>
  );
}

DeployedIntegrationsLoadingIndicator.propTypes = {
  loading: PropTypes.bool.isRequired,
};
